import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { organisationsQueryOptions } from '@/api/resources/organisations'
import { LoadingSpinner } from '@/components/feedback/loading-spinner'
import { PageHeader } from '@/components/layout/page-header'
import { OrganisationCard } from '@/components/organisations/organisation-card'

export const Route = createFileRoute('/_app/organisations/')({
  head: () => ({ meta: [{ title: 'Organisations - MyJunea' }] }),
  component: OrganisationsPage,
})

function OrganisationsPage(): React.ReactElement {
  const { data: organisations, isLoading } = useQuery(organisationsQueryOptions())

  return (
    <div className="space-y-6">
      <PageHeader
        title="Organisations"
        description="Manage your organisations, locations, and settings."
      />

      {isLoading && <LoadingSpinner />}

      {!isLoading && (organisations === undefined || organisations.length === 0) && (
        <p className="text-muted-foreground py-10 text-center">No organisations found.</p>
      )}

      {organisations !== undefined && organisations.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {organisations.map((organisation) => (
            <Link
              key={organisation.id}
              to="/organisations/$organisationId"
              params={{ organisationId: String(organisation.id) }}
              className="focus-visible:ring-ring min-w-0 rounded-xl transition-transform hover:scale-[1.02] focus-visible:ring-2 focus-visible:outline-none"
            >
              <OrganisationCard
                name={organisation.name}
                locationCount={organisation.locations_count}
                machineCount={organisation.machines_count}
                warningCount={organisation.machines_with_warnings_count}
                className="h-full"
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
